export const state = () => ({
	faqs: null,
});

export const mutations = {
	setFaqs(state: any, payload: any) {
		state.faqs = payload;
	},
};

export const getters = {
	getFaqs: (state: any) => state.faqs,
};

export const actions = {
	async fetchFaqs(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/faqs')
				.then((res) => {
					state.commit('setFaqs', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
